function initDocEvents() {
    $(window).on( 'resize orientationchange', addEndEvent );
    $(window).on( 'resizeEnd', resizeHandler );
    $(window).on( 'scroll', scrollHandler );
    $('body').off('reveal').on('reveal', '.sr', scrollRevealHandler);
}

function events(wait, immediate, func ) {
    var timeout;

    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

var addEndEvent = events( 200, false, function(e) {
    $(this).trigger(e.type + 'End');
});

/* Fonctions exécutées à chaque resize */
var resizeHandler = function() {
    $(window).trigger('scroll');
    initScrollAnimations();
    resizeParallax();

    /* Autres fonctions jouées au resize */
    $('.slick-arrow').text('');
    // resizeSlider();
    // resizeNav();
};


/*
########      ###     ########      ###     ##         ##            ###     ##     ##
##     ##    ## ##    ##     ##    ## ##    ##         ##           ## ##     ##   ##
##     ##   ##   ##   ##     ##   ##   ##   ##         ##          ##   ##     ## ##
########   ##     ##  ########   ##     ##  ##         ##         ##     ##     ###
##         #########  ##   ##    #########  ##         ##         #########    ## ##
##         ##     ##  ##    ##   ##     ##  ##         ##         ##     ##   ##   ##
##         ##     ##  ##     ##  ##     ##  ########   ########   ##     ##  ##     ##
*/

/*	Permet l’ajout rapide d’effets parallax sur n'importe quel bloc.
	L’animation se joue obligatoirement sur la hauteur complète du viewport.
	Les réglages sont recalculés après chaque resize du viewport.

	Utilisation :
	- Ajouter la classe "parallax" à l’élément que l’on souhaite animer
	- Tous les autres attributs sont facultatifs
	- data-direction : défini l’orientation de l’animation. Défaut : 'vertical'
	- data-start : l’offset au départ de l’animation. en pixels ou %. Defaut : 0
	- data-end : l’offset à la fin de l’animation. en pixels ou %. Defaut : 0

	Il est possible de définir le breakpoint à partir duquel ce déclenche les animations.
	Ce réglage (via la variable "parallaxBreakpoint") est modifiable dans la section CONF
	du fichier zz-mcube.js
*/

// Définition du breakpoint d'initialisation des effets parallax
var parallaxBreakpoint = 768;

var ctrlParallax;
var sceneParallax = [];
var initParallax = function() {

    if ( jQuery(window).width() > parallaxBreakpoint ) {
        ctrlParallax = new ScrollMagic.Controller();
        jQuery('body').addClass('ctrlParallax');
    }

    jQuery('.parallax').each(function( index ) {
        jQuery(this).css({ transform: '' });

        if ( jQuery(window).width() > parallaxBreakpoint ) {
            var start      = jQuery(this).attr( 'data-start' );
            var end        = jQuery(this).attr( 'data-end' );
            var direction  = jQuery(this).attr( 'data-direction' );
            if ( start     === undefined ) start = 0;
            if ( end       === undefined ) end = 0;
            if ( direction === undefined ) direction = "vertical";

            var windowHeight  = jQuery(window).height();
            var elementOffset = jQuery(this).offset().top;
            var elementHeight = jQuery(this).outerHeight();
            var offset        = ( elementOffset - windowHeight );

            var tween;
            if ( direction == 'horizontal' ) {
                tween = TweenMax.fromTo( this, 1, { x: start }, { x: end, ease: Power0.easeNone } );
            } else {
                tween = TweenMax.fromTo( this, 1, { y: start }, { y: end, ease: Power0.easeNone } );
            }

            sceneParallax[index] = new ScrollMagic.Scene({
                offset: offset,
                triggerHook: 'onEnter'
            })
                .setTween( tween )
                .addTo( ctrlParallax );
        }
    });
};

var resizeParallax = function() {
    if ( jQuery(window).width() > parallaxBreakpoint )  {
        if ( ! jQuery('body').hasClass('ctrlParallax') ) {
            initParallax();
        } else {
            ctrlParallax.enabled(true);
            ctrlParallax.update(true);
        }
    } else {
        if ( jQuery('body').hasClass('ctrlParallax') ) {
            jQuery('body').removeClass('ctrlParallax');
            ctrlParallax.destroy(true);
        }
    }

    if ( jQuery(window).width() > parallaxBreakpoint ) {
        if ( ctrlParallax.enabled() ) {
            jQuery('.parallax').each(function( index ) {

                var elementDuration  = jQuery(this).attr( 'data-duration' );
                if ( elementDuration === undefined ) elementDuration = 1;

                var windowHeight  = jQuery(window).height();
                var elementOffset = jQuery(this).offset().top;
                var elementHeight = jQuery(this).outerHeight();
                var offset        = ( elementOffset - windowHeight );
                var duration      = ( windowHeight  + elementHeight );

                sceneParallax[index].duration(duration);
                sceneParallax[index].offset(offset);
                sceneParallax[index].update(true);
            });
        }
    } else {
        jQuery('.parallax').each(function( index ) {
            jQuery(this).css({ transform: '' });
        });
    }
};